import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Button
} from '@mui/material';
import tableStyle from '../../../../styles/tableStyle';
import RowDelete from '../../../../components/RowDelete';
import CashjobRowDelete from '../../../../components/CashjobRowDelete';

const firstRow = {
    description: "",
    id: 1,
    Qty: "",
    Rate: "",
    Amount: "",
}
function TypeTask({rows, setRows, addRow, handleDelete }) {
    const [hoveredRow, setHoveredRow] = useState(null);

    const handleRowMouseEnter = (rowId) => {
      setHoveredRow(rowId);
    };
  
    const handleRowMouseLeave = () => {
      setHoveredRow(null);
    };
    const columns = [
        { id: 'id', label: 'No' },
        { id: 'description', label: 'Type' },
        { id: 'qty', label: 'Qty' },
        { id: 'Rate', label: 'Rate' },
        { id: 'amt', label: 'Amount' },
    ];

    const handleFieldChange = (e, id, field) => {
        const updatedRows = rows.map((row) => {
            if (row.id === id) {
                row[field] = e.target.value;
                if (field === 'qty' || field === 'Rate') {
                    row.amt = parseFloat(row.Rate) * row.qty
                }
            }
            return row;        
        });
        setRows(updatedRows);
    };

    

    return (
        <TableContainer component={Paper}>
            <Table aria-label="sticky table" size="small" sx={{minWidth: 1000}}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} style={column.id === 'description' ? { width: 400 } : {width: 100}}>
                                <b>{column.label}</b>
                            </TableCell>
                        ))}
                        <TableCell></TableCell> {/* Placeholder for delete button column */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id} onMouseEnter={() => handleRowMouseEnter(row.id)} onMouseLeave={() => handleRowMouseLeave(row.id)}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>
                            {row.CashJobId ? row.description :
                             <TextField
                             InputProps={{
                                 style: tableStyle.root
                             }}
                             fullWidth
                             variant="outlined"
                             size="small"
                             value={row.description}
                             onChange={(e) => handleFieldChange(e, row.id, 'description')}
                         />
                            }
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.qty}
                                    onChange={(e) => handleFieldChange(e, row.id, 'qty')}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.Rate}
                                    onChange={(e) => handleFieldChange(e, row.id, 'Rate')}
                                />
                            </TableCell>
                            <TableCell>
                                {row.amt}
                            </TableCell>

                            <TableCell>
                                <CashjobRowDelete rows={rows} rowId={row.id} setRows={setRows} firstRow={firstRow} field='qty' hoveredRow={hoveredRow} handleDelete={handleDelete}/>
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={5}><Button onClick={()=> addRow({})} variant='contained' sx={{height: '30px', backgroundColor: '#489C8F', display: 'flex', alignItems: 'center'}}>Add Type</Button></TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default TypeTask